var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import * as React from 'react';
import { useEffect, useState } from 'react';
import get from "lodash/get";
import set from "lodash/set";
import { CommonApis, JourneysSelectors, ResultsSelectors, useAppSelector } from 'conversional-journey';
import { objectUtil } from "conversional-utils";
import Loading from "../loading/Loading";
import createComponentsFromObject from "../../utilities/components/createComponentsFromObject";
var ContextComponentWrapper = function (_a) {
    var contextId = _a.contextId, contextProps = _a.contextProps, overrideConfig = _a.overrideConfig, componentKey = _a.componentKey;
    // Resolved definitions component
    var _b = useState(null), component = _b[0], setComponent = _b[1];
    var journeyId = useAppSelector(JourneysSelectors.currentJourneyId);
    // Getting journey and result for resolving definitions
    var journey = useAppSelector(JourneysSelectors.currentJourney);
    var result = useAppSelector(ResultsSelectors.selectResultsState);
    var theme = useAppSelector(JourneysSelectors.selectTheme);
    var _c = CommonApis.useFetchContextComponentQuery({
        contextId: contextId,
        journeyId: journeyId
    }), data = _c.data, error = _c.error, isLoading = _c.isLoading;
    useEffect(function () {
        var componentConfiguration = get(data, contextId, null);
        if (componentConfiguration) {
            var definitionSource = { contextProps: contextProps };
            if (journey)
                definitionSource = __assign(__assign({}, definitionSource), journey);
            if (result)
                definitionSource = __assign(__assign({}, definitionSource), result);
            var resolvedComponent_1 = objectUtil.resolveDefinitions(componentConfiguration, definitionSource);
            if (Array.isArray(overrideConfig))
                overrideConfig.forEach(function (_a) {
                    var path = _a.path, value = _a.value;
                    return set(resolvedComponent_1, path, value);
                });
            if (!get(resolvedComponent_1, 'Content.componentKey'))
                set(resolvedComponent_1, 'Content.componentKey', componentKey);
            setComponent(resolvedComponent_1);
        }
    }, [JSON.stringify(data), JSON.stringify(contextProps)]);
    if (isLoading || !component)
        return _jsx(Loading, {});
    return _jsx(_Fragment, { children: createComponentsFromObject({ component: component }) });
};
export default ContextComponentWrapper;
